import { Fragment, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { deviseSignIn, continueAfterLogin } from '@polydice/icook-devise-unify';
import { triggerToast } from '@polydice/ui/dist/Toast';
import styles from './style.module.scss';
import { captureException } from '@sentry/browser';
import { getAuthToken } from 'reactjs/components/utility';
import Button from '@polydice/ui/dist/Button';
import IconButton from '@polydice/ui/dist/IconButton';
import classNames from 'classnames';

const FavoriteButton = ({
  user,
  endpoint,
  isFavoriteInit,
  darkMode = false
}) => {
  const [isFavorite, setIsFavorite] = useState(isFavoriteInit);
  const [isWaitingResponse, setIsWaitingResponse] = useState(false);

  const continueAfterLoginKey = `market_product_favorite_${endpoint}`;

  const changeFavoriteState = useCallback(async () => {
    const nextFavoriteState = !isFavorite;
    setIsWaitingResponse(true);

    try {
      const resopnse = await fetch(endpoint, {
        method: nextFavoriteState ? 'POST' : 'DELETE',
        credentials: 'include',
        headers: {
          'X-CSRF-Token': getAuthToken()
        }
      });
      if (resopnse.ok) {
        triggerToast({
          className: 'toast',
          text: nextFavoriteState ? '已加入「商品收藏」' : '已取消「商品收藏」',
          closable: true
        });
        setIsFavorite(nextFavoriteState);
      } else {
        setIsFavorite(isFavorite);
      }
    } catch (error) {
      captureException(error);
    }

    setIsWaitingResponse(false);
  }, [endpoint, isFavorite]);

  const invokeLoginModal = () => {
    deviseSignIn({
      entry: 'market_add_product_save',
      redirect: window.location.href,
      continueAfterLogin: continueAfterLoginKey,
      in_web: 1
    });
  };

  useEffect(() => {
    if (continueAfterLogin(continueAfterLoginKey) && !isFavorite)
      changeFavoriteState();
  }, [changeFavoriteState, continueAfterLoginKey, isFavorite]);

  return (
    <Fragment>
      <IconButton
        className={classNames(styles.favoriteButtonMobile, {
          'dark-mode transparent-bgc mobile-gray2-bgc no-border': darkMode
        })}
        shape="square"
        color="white"
        outline="border"
        iconOnClass="bookmark-solid"
        iconOffClass="bookmark-regular"
        data-label-on="加入收藏"
        data-label-off="移除收藏"
        pressed={isFavorite}
        onClick={user ? changeFavoriteState : invokeLoginModal}
      />
      <Button
        className={classNames(styles.favoriteButtonDesktop, {
          'dark-mode gray2-bgc white-border': darkMode
        })}
        styleType="outlined"
        color="secondary"
        icon={isFavorite ? 'bookmark-solid' : 'bookmark-regular'}
        unfulfilled={isWaitingResponse}
        onClick={user ? changeFavoriteState : invokeLoginModal}
      >
        {isFavorite ? '我已收藏' : '加入收藏'}
      </Button>
    </Fragment>
  );
};

FavoriteButton.propTypes = {
  user: PropTypes.shape({}),
  endpoint: PropTypes.string.isRequired,
  isFavoriteInit: PropTypes.bool.isRequired
};

FavoriteButton.defaultProps = {
  user: null
};

export default FavoriteButton;
